package org.hs_soft.runmynesto.domain.usecase.options.restaurant_manager

import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.create_update_room.CreateUpdateRestaurantRoomModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.restaurant_manager.UpdateRoomRepository


class UpdateRoomUseCase(
    private val repository: UpdateRoomRepository,
) {
    suspend operator fun invoke(
        caption:String,
        roomId:String,
    ): CreateUpdateRestaurantRoomModel {
        return repository.updateRoom(
            caption=caption,
            roomId=roomId,
        )
    }
}